import React, { useEffect, useState } from 'react';
import AIPsychologist from './components/AIPsychologist';
import apiService from './services/apiService';
import './App.css';

function App() {
  const [serverStatus, setServerStatus] = useState('checking');
  const [error, setError] = useState(null);

  useEffect(() => {
    // Verificar si el servidor está funcionando
    const checkServerHealth = async () => {
      try {
        await apiService.checkHealth();
        setServerStatus('online');
      } catch (err) {
        console.warn('Server not responding, using fallback mode:', err);
        setServerStatus('offline');
        setError('Servidor no disponible. Usando modo offline.');
      }
    };

    checkServerHealth();
  }, []);

  if (serverStatus === 'checking') {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          background: 'rgba(255, 255, 255, 0.95)',
          borderRadius: '24px',
          padding: '2rem',
          textAlign: 'center',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
        }}>
          <div style={{
            animation: 'spin 1s linear infinite',
            borderRadius: '50%',
            height: '48px',
            width: '48px',
            borderTop: '4px solid #667eea',
            borderRight: '4px solid transparent',
            margin: '0 auto 1rem'
          }}></div>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#4a5568', marginBottom: '0.5rem' }}>
            MindWise AI
          </h2>
          <p style={{ color: '#718096' }}>Iniciando tu asistente psicológico...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {/* Notificación de estado del servidor */}
      {error && (
        <div style={{
          position: 'fixed',
          top: '1rem',
          right: '1rem',
          zIndex: 50,
          background: '#fef3c7',
          border: '1px solid #fbbf24',
          color: '#92400e',
          padding: '0.75rem 1rem',
          borderRadius: '0.5rem',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ fontSize: '0.875rem' }}>⚠️ {error}</span>
          </div>
        </div>
      )}

      {/* Componente principal */}
      <AIPsychologist />

      {/* Footer con información */}
      <footer style={{
        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.9), rgba(118, 75, 162, 0.9))',
        color: 'white',
        textAlign: 'center',
        padding: '1.5rem',
        marginTop: 'auto'
      }}>
        <div style={{ maxWidth: '64rem', margin: '0 auto', padding: '0 1rem' }}>
          <p style={{ fontSize: '0.875rem', opacity: 0.9, marginBottom: '0.5rem' }}>
            💙 MindWise AI - Tu psicólogo virtual de confianza
          </p>
          <p style={{ fontSize: '0.75rem', opacity: 0.7, marginBottom: '0.75rem' }}>
            Este es un asistente de apoyo emocional. Para emergencias o crisis graves, contacta a un profesional de salud mental.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '0.5rem', fontSize: '0.75rem', gap: '1rem', flexWrap: 'wrap' }}>
            <span style={{ display: 'flex', alignItems: 'center', color: serverStatus === 'online' ? '#86efac' : '#fde047' }}>
              <div style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                background: serverStatus === 'online' ? '#4ade80' : '#facc15',
                marginRight: '0.25rem',
                animation: 'pulse 2s infinite'
              }}></div>
              {serverStatus === 'online' ? '✓ Servidor conectado' : '⚠ Modo offline'}
            </span>
            <span style={{ opacity: 0.6 }}>|</span>
            <span style={{ opacity: 0.7 }}>
              Desarrollado por Thiago Diaz
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;